import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const getCityApi = createAsyncThunk('city', async (id) => {
    const response = await axiosInstance.get(`/city/${id}`);
    return response.data;
});

const citySlice = createSlice({
    name: "city",
    initialState: {
        data: [],
        errors: [],
        loading: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCityApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(getCityApi.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(getCityApi.rejected, (state, action) => {
                state.errors.push(action.error.message);
                state.loading = false;
            });
    }
});

export default citySlice.reducer;
